module.exports = __webpack_public_path__ + "img/signup_mask-bottom.046f3b81.svg";